import { statusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';
import { ColumnHeaderUi, PagingUi } from '@/components/TableData/TableDataUi';

export type GlobalOrdersUi = {
  columnHeaders: ColumnHeaderUi[];
  items: GlobalOrderItemUi[];
  paging?: PagingUi;
  selectedOrder?: SelectedOrderUi;
  isLoadingOrderDetails?: boolean;
  isLoading?: boolean;
  orderDetailsError?: string;
};

export type GlobalOrderItemUi = {
  id: string;
  orderNumber: string;
  buyerBusinessName: string;
  adminName: string;
  paymentMethod: string;
  createdAt: string;
  totalOrderAmount: string;
};

export type SelectedOrderUi = {
  details: SelectedOrderDetailsUi[];
};

export type SelectedOrderDetailsUi = {
  orderId: string;
  orderNumber: string;
  sellerName: string;
  sellerImage: string;
  totalOrderAmount: string;
  productQuantity: string;
  badge: statusBadgeUi;
};

const tableHeaders = [
  { label: 'ID Pedido' },
  { label: 'Comprador' },
  { label: 'KAM' },
  { label: 'Fecha de pedido' },
  { label: 'Método de Pago' },
  { label: 'Total' },
  { label: '' },
];

export const initialState: GlobalOrdersUi = {
  columnHeaders: tableHeaders,
  items: [],
};
